import PermisssionProfile from './container/index.js';

export default PermisssionProfile;



// WEBPACK FOOTER //
// ./src/views/Setup/PermissionProfile/index.js